'use client';

import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { cssColorValue, cssSpacing, rootStyle, semanticColors } from "../../styles/index.mjs";
import styled from "../../styled-components.mjs";
var HorizontalRuleElement = styled.hr.withConfig({
  displayName: "HorizontalRule__HorizontalRuleElement",
  componentId: "sc-198gjx4-0"
})(["", ";border:0;border-block-start:1px solid ", ";margin-block-end:", ";margin-block-start:", ";"], rootStyle(), cssColorValue(semanticColors.decorativeSubdued), cssSpacing('looser', '24px'), cssSpacing('looser', '24px'));
export var HorizontalRule = function HorizontalRule(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(HorizontalRuleElement, Object.assign({}, props, {
    "data-encore-id": ENCORE_DATA_IDS.HorizontalRule
  }));
};